import { http, getApiBaseUrl } from '@/api/client'
import type { RegisterFinishResponse, TokenPair, Uuid } from '@/api/types'

interface ChallengeResponse {
  challengeId: Uuid
  options: Record<string, unknown>
}

export const registerBegin = (inviteCode: string) =>
  http.post<ChallengeResponse>('/v0/auth/register/begin', { inviteCode }, { skipAuth: true })

export const registerFinish = (challengeId: Uuid, credential: unknown) =>
  http.post<RegisterFinishResponse>(
    '/v0/auth/register/finish',
    { challengeId, credential },
    { skipAuth: true },
  )

export const loginBegin = () =>
  http.post<ChallengeResponse>('/v0/auth/login/begin', undefined, { skipAuth: true })

export const loginFinish = (challengeId: Uuid, credential: unknown) =>
  http.post<TokenPair>('/v0/auth/login/finish', { challengeId, credential }, { skipAuth: true })

export const recoveryBegin = (email: string, code: string) =>
  http.post<ChallengeResponse>('/v0/auth/recovery/begin', { email, code }, { skipAuth: true })

export const recoveryFinish = (challengeId: Uuid, credential: unknown) =>
  http.post<TokenPair>('/v0/auth/recovery/finish', { challengeId, credential }, { skipAuth: true })

export const logoutAll = () => http.post<void>('/v0/auth/logout-all')

/**
 * Выход мимо общего клиента: ручка принимает **refresh**-токен, а не access.
 *
 * Пропускать его через `http` нельзя — тот подставит access и при 401 попытается обновиться,
 * то есть продлит сессию ровно в момент выхода из неё.
 */
export async function logout(refreshToken: string): Promise<void> {
  await fetch(`${getApiBaseUrl()}/v0/auth/logout`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refreshToken }),
  })
}
